export const componentNames = {}
console.log("componentNames :>> ", componentNames)

export class ChildrenItem {
  //组件通用配置项
  constructor(name, thumbnail, shape, options, cover) {
    this.name = name
    this.thumbnail = thumbnail
    this.attribute = {
      draggable: true,
      resizable: true,
      parentLim: true,
      hoverZIndex: 1,
      color: "rgba(239,154,154,1)",
      active: false,
      shape,
      options: this.initOptions(options),
      ...new VDRAttribute()
    }
    this.cover = cover
    this.updateComponentNameMap(this.name, shape)
  }
  updateComponentNameMap(name, shape) {
    if (componentNames[shape] === undefined) {
      componentNames[shape] = name.indexOf("样式")>-1?name.slice(0, name.indexOf("样式")):name
    }
  }
  initOptions(opt) {
    opt.eventQuery = "" //事件接口参数
    opt.zIndex = 0
    return opt
  }
}
export class VDRAttribute {
  //vdr插件通用配置项
  constructor() {
    this.draggable = true
    this.resizable = true
    this.parentLim = true
  }
}
export const publicComponentOption = {
  width: "宽度",
  height: "高度",
  left: "左边距",
  top: "上边距",
  eventQuery: "接口参数",
  rotate: "旋转角度",
  pluginName: "插件名"
}
